<ng-container [ngSwitch]="!!metrics">
  <ng-container *ngSwitchCase="true">
    <app-overview-metric
      *ngFor="let metric of metrics"
      class="overview-metric"
      [type]="metric.type"
      [label]="metric.label"
      [data]="metric.data"
      [cta]="metric.cta"
      [miniSize]="miniSize"
      [trackingObject]="trackingObject"
      [trackingScreenName]="trackingScreenName"
    >
    </app-overview-metric>
  </ng-container>

  <ng-container *ngSwitchDefault>
    <div
      *ngFor="let i of numberOfPlaceholderMetrics | fill"
      class="placeholder-metric"
    >
      <div class="vertical-bar shimmer"></div>

      <div class="placeholder-contents">
        <div class="placeholder-header shimmer"></div>
        <div class="placeholder-body shimmer"></div>
        <div class="placeholder-cta shimmer"></div>
      </div>
    </div>
  </ng-container>
</ng-container>
